module.exports = __webpack_public_path__ + "img/Select-Items.39394561.png";